"use strict";

import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import React from "react";
import { observer } from "mobx-react";
import { FolderComponent } from "./FolderComponent/FolderComponent";
import { Folder, OptionsVertical } from "../../icons";
import TextInput, { TextInputSize } from "../TextInput/TextInput";
import { OptionMenu, OptionMenuItem } from "../OptionMenu";
import IconButton from "../IconButton/IconButton";
import { ButtonSize } from "../Button/Button";
import { action, observable } from "mobx";
import { duration } from "../../../tokens/tokens-css";
import { Transition } from "react-transition-group";
import OptionMenuSeparator from "../OptionMenu/OptionMenuSeparator";
import * as styles from "./TreebeardHeader-css";
export var TreebeardHeader = /*#__PURE__*/function (_React$Component) {
  _inherits(TreebeardHeader, _React$Component);
  var _super = _createSuper(TreebeardHeader);
  function TreebeardHeader(props) {
    var _this;
    _classCallCheck(this, TreebeardHeader);
    _this = _super.call(this, props);
    _this.isRenaming = false;
    _this.newName = null;
    _this.isHovering = false;
    _this.isFocused = false;
    _this.startRenaming = function () {
      _this.isRenaming = true;
    };
    _this.createNewFolder = function () {
      var _a;
      if ((_a = _this.props.node) == null ? void 0 : _a.onCreateFolder) {
        _this.props.node.onCreateFolder(_this.props.node.id);
      }
    };
    _this.deleteFolder = function () {
      var _a;
      if ((_a = _this.props.node) == null ? void 0 : _a.onDeleteFolder) {
        _this.props.node.onDeleteFolder(_this.props.node.id);
      }
    };
    _this.setIsHovering = function (newValue) {
      _this.isHovering = newValue;
    };
    _this.setIsFocused = function (newValue) {
      _this.isFocused = newValue;
    };
    _this.renameConfirm = function () {
      if (_this.isRenaming) {
        var _this$props$node = _this.props.node,
          id = _this$props$node.id,
          onRenameConfirm = _this$props$node.onRenameConfirm;
        if (!!_this.newName) {
          if (!!onRenameConfirm) {
            onRenameConfirm(id, _this.newName);
          }
        } else {
          _this.renameCancel();
        }
        _this.resetRename();
      }
    };
    _this.resetRename = function () {
      _this.isRenaming = false;
      _this.isHovering = false;
      _this.isFocused = false;
      _this.newName = null;
    };
    _this.dragStartHandler = _this.dragStartHandler.bind(_assertThisInitialized(_this));
    _this.dropHandler = _this.dropHandler.bind(_assertThisInitialized(_this));
    _this.renameCancel = _this.renameCancel.bind(_assertThisInitialized(_this));
    _this.renameConfirm = _this.renameConfirm.bind(_assertThisInitialized(_this));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.keyPressed = _this.keyPressed.bind(_assertThisInitialized(_this));
    _this.inputElement = React.createRef();
    _this.isRenaming = props.node.renaming;
    return _this;
  }
  _createClass(TreebeardHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props$node2 = this.props.node,
        className = _this$props$node2.className,
        selected = _this$props$node2.selected,
        name = _this$props$node2.name,
        toggled = _this$props$node2.toggled,
        children = _this$props$node2.children,
        id = _this$props$node2.id,
        disableSelect = _this$props$node2.disableSelect,
        isBeingDragged = _this$props$node2.isBeingDragged,
        draggable = _this$props$node2.draggable,
        onDragEnd = _this$props$node2.onDragEnd,
        disableOptions = _this$props$node2.disableOptions;
      var hasSubfolders = children.length > 0;
      return /* @__PURE__ */React.createElement("div", {
        id: "tree-".concat(id, "-folder"),
        className: styles.folder,
        "aria-expanded": hasSubfolders ? toggled : void 0,
        draggable: draggable && !this.isRenaming,
        onDragStart: this.dragStartHandler,
        onDragEnd: onDragEnd,
        onMouseEnter: function onMouseEnter() {
          return _this2.setIsHovering(true);
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.setIsHovering(false);
        },
        onMouseOver: function onMouseOver() {
          return _this2.setIsHovering(true);
        },
        onFocus: function onFocus() {
          return _this2.setIsFocused(true);
        },
        onBlur: function onBlur() {
          return _this2.setIsFocused(false);
        }
      }, /* @__PURE__ */React.createElement(FolderComponent, {
        hasMenuOption: !disableOptions,
        icon: /* @__PURE__ */React.createElement(Folder, null),
        element: this.isRenaming ? "div" : "button",
        name: name,
        selected: selected,
        onClick: this.isRenaming ? void 0 : function () {
          if (_this2.props.onSelect) {
            _this2.props.onSelect(_this2.props.node);
          }
        },
        onDrop: this.dropHandler,
        overrideNameComponent: this.isRenaming ? this.renderRenameInput() : void 0,
        endElement: !disableOptions && !this.isRenaming ? /* @__PURE__ */React.createElement("div", {
          className: styles.menuSpacer
        }) : void 0,
        disableSelect: disableSelect,
        disableDrop: isBeingDragged
      }), !disableOptions && /* @__PURE__ */React.createElement(Transition, {
        mountOnEnter: true,
        unmountOnExit: true,
        in: !this.isRenaming && (this.isHovering || this.isFocused),
        timeout: duration.s
      }, function (status) {
        return /* @__PURE__ */React.createElement(OptionMenu, {
          className: "".concat(className, "__action-menu"),
          onClose: function onClose() {
            _this2.isFocused = false;
          },
          size: "small",
          button: /* @__PURE__ */React.createElement(IconButton, {
            "aria-label": "Folder options",
            className: styles.actions({
              visible: ["entering", "entered"].includes(status)
            }),
            icon: /* @__PURE__ */React.createElement(OptionsVertical, null),
            size: ButtonSize.Small
          })
        }, /* @__PURE__ */React.createElement(OptionMenuItem, {
          onClick: _this2.createNewFolder
        }, "New folder"), /* @__PURE__ */React.createElement(OptionMenuItem, {
          onClick: _this2.startRenaming
        }, "Rename folder"), /* @__PURE__ */React.createElement(OptionMenuSeparator, null), /* @__PURE__ */React.createElement(OptionMenuItem, {
          onClick: _this2.deleteFolder,
          destructive: true
        }, "Delete folder"));
      }));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!!this.inputElement.current) {
        this.inputElement.current.focus();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this3 = this;
      if (this.isRenaming) {
        setTimeout(function () {
          var _a, _b;
          (_b = (_a = _this3.inputElement) == null ? void 0 : _a.current) == null ? void 0 : _b.focus();
        }, 10);
      }
    }
  }, {
    key: "dragStartHandler",
    value: function dragStartHandler(event) {
      var _this$props$node3 = this.props.node,
        onDragStart = _this$props$node3.onDragStart,
        id = _this$props$node3.id;
      onDragStart(event, id);
    }
  }, {
    key: "dropHandler",
    value: function dropHandler(event) {
      var _this$props$node4 = this.props.node,
        onDropOnFolder = _this$props$node4.onDropOnFolder,
        id = _this$props$node4.id;
      if (!!onDropOnFolder) {
        onDropOnFolder(event, id);
      }
    }
  }, {
    key: "renameCancel",
    value: function renameCancel() {
      var _this$props$node5 = this.props.node,
        id = _this$props$node5.id,
        onRenameCancel = _this$props$node5.onRenameCancel;
      if (!!onRenameCancel) {
        onRenameCancel(id);
      }
      this.resetRename();
    }
  }, {
    key: "keyPressed",
    value: function keyPressed(event) {
      switch (event.key) {
        case "Enter":
          this.renameConfirm();
          break;
        case "Escape":
          this.renameCancel();
          break;
      }
    }
  }, {
    key: "onChange",
    value: function onChange(value) {
      this.newName = value;
      var _this$props$node6 = this.props.node,
        id = _this$props$node6.id,
        onNameChange = _this$props$node6.onNameChange;
      if (!!onNameChange) {
        onNameChange(id, this.newName);
      }
    }
  }, {
    key: "renderRenameInput",
    value: function renderRenameInput() {
      var _this$props$node7 = this.props.node,
        name = _this$props$node7.name,
        maxNameLength = _this$props$node7.maxNameLength;
      if (this.newName === null) {
        this.newName = name;
      }
      return /* @__PURE__ */React.createElement(TextInput, {
        labelHidden: true,
        ref: this.inputElement,
        className: styles.input,
        label: "Folder name",
        size: TextInputSize.Small,
        value: this.newName,
        onChange: this.onChange,
        onBlur: this.renameConfirm,
        onKeyDown: this.keyPressed,
        maxLength: maxNameLength,
        onClick: function onClick(e) {
          e.stopPropagation();
        }
      });
    }
  }]);
  return TreebeardHeader;
}(React.Component);
__decorateClass([observable.ref], TreebeardHeader.prototype, "isRenaming", 2);
__decorateClass([observable.ref], TreebeardHeader.prototype, "newName", 2);
__decorateClass([observable.ref], TreebeardHeader.prototype, "isHovering", 2);
__decorateClass([observable.ref], TreebeardHeader.prototype, "isFocused", 2);
__decorateClass([action], TreebeardHeader.prototype, "startRenaming", 2);
__decorateClass([action], TreebeardHeader.prototype, "setIsHovering", 2);
__decorateClass([action], TreebeardHeader.prototype, "setIsFocused", 2);
__decorateClass([action], TreebeardHeader.prototype, "renameCancel", 1);
__decorateClass([action], TreebeardHeader.prototype, "renameConfirm", 2);
__decorateClass([action], TreebeardHeader.prototype, "resetRename", 2);
__decorateClass([action], TreebeardHeader.prototype, "onChange", 1);
TreebeardHeader = __decorateClass([observer], TreebeardHeader);